import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class ErrorHandlerService {
    public handleError(error: HttpErrorResponse): CustomHttpErrorResponse {
        let errorMessage = 'An error occurred';

        if (error.status >= 500 && error.status < 600) {
            errorMessage = 'Server error: Please try again later or contact support.';
        } else {
            errorMessage = error.message || errorMessage;
        }

        // Create a new HttpErrorResponse with the modified message
        const modifiedError: CustomHttpErrorResponse = {
            ...error, // Spread the original error properties
            message: errorMessage,
        };

        return modifiedError;
    }
}

export interface CustomHttpErrorResponse extends HttpErrorResponse {
    message: string;
}
